import classNames from 'classnames';
import { FC } from 'react';

import { useLoadingBarPresenter } from './LoadingBar.presenter';
import styles from './LoadingBar.styles.m.css';

interface ILoadingBarProps {
  loading: boolean;
  className: string;
}

export const LoadingBar: FC<ILoadingBarProps> = ({ className, loading }) => {
  const presenter = useLoadingBarPresenter({ loading });

  if (!presenter.isShow) {
    return null;
  }

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={styles.progress}
        style={{ width: presenter.progress + '%' }}
      />
    </div>
  );
};
